import cx from 'classnames'
import React, { PureComponent } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import styles from './List.css'
import { length } from 'redux-form-validators'
import { Icon, Button } from '@vzmi/shp_shared_compo'
import { Field } from '../../../../../../Common/forms'
import { skipRequiredThenValidate } from '../../../../../Common/ProposalForm/Shared/validation/validations'
import { ListingFieldConfig } from '../../../../../Common/ProposalForm/Shared/FieldConfig'
import { required } from '../../../../../../../lib/FormHelper'
import dragIcon from '@vzmi/svg-icons-ec/icons/drag'

const getItemStyle = (isDragging, draggableStyle) => {
  return ({
    // styles we need to apply on draggables
    ...draggableStyle
  })
}

const validateDuplicateSpecItem = (fieldIndex) => (value, formValues) => {
  const { specItems = [] } = formValues
  const hasDuplicate = specItems.some((o, i) => {
    return i !== fieldIndex && o.value === value
  })
  return hasDuplicate ? '項目名稱不可相同，請調整項目名稱' : null
}

export default class List extends PureComponent {
  renderSpecItems = () => {
    const { fields, exceedLength } = this.props
    const specItemMaxLength = exceedLength >= 0 ? exceedLength : 0
    return fields.map((specFieldName, fieldIndex) => {
      const field = fields.get(fieldIndex)
      const { oldValue, value } = field
      const fieldName = `${specFieldName}.value`
      const resettable = (oldValue !== value)
      return (
        <Draggable
          key={field.id}
          draggableId={field.id}
          index={fieldIndex}
        >
          {(provided, snapshot) => {
            return (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                data-role='spec-item-dnd-list-item'
                className={cx(styles.Item, {
                  [styles.dragging]: snapshot.isDragging,
                  [styles.resettable]: resettable
                })}
                style={getItemStyle(
                  snapshot.isDragging,
                  provided.draggableProps.style
                )}
              >
                <Icon
                  asset={dragIcon}
                  size={22}
                  key='drag'
                  color='#979ba7'
                  className={styles.mover}
                />
                <Field
                  key='specItem'
                  {...ListingFieldConfig.getField('product.name')}
                  name={fieldName}
                  className={styles.modalInputField}
                  countLimit={specItemMaxLength}
                  placeholder={`最多輸入${specItemMaxLength}個字`}
                  inlineCount
                  disabled={specItemMaxLength === 0}
                  validate={skipRequiredThenValidate(required(), length({ max: specItemMaxLength }), validateDuplicateSpecItem(fieldIndex))}
                />
                {resettable && (
                  <Button
                    key='resetButton'
                    data-role='reset-button'
                    link
                    size='medium'
                    className={styles.resetButton}
                    onClick={() => this.props.triggerFieldChange(fieldName, oldValue)}
                  >
                    恢復預設
                  </Button>
                )}
                <Button
                  key='deleteButton'
                  link
                  data-role='delete-button'
                  size='medium'
                  className={styles.deleteButton}
                  onClick={() => fields.remove(fieldIndex)}
                  iconType='delete'
                />
              </div>
            )
          }}
        </Draggable>
      )
    })
  }

  render () {
    return (
      <DragDropContext
        onDragEnd={this.props.onDragEnd}
      >
        <Droppable droppableId='droppable'>
          {(provided, snapshot) => (
            <div
              className={styles.List}
              data-role='spec-item-dnd-list'
              ref={provided.innerRef}
            >
              {this.renderSpecItems()}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}
